export const content = {
  acquainted: {id: 'acquainted', defaultMessage: 'Let\'s get acquainted'},
  developer: {id: 'developer', defaultMessage: 'I am cool frontend developer'},
  slow_experience: {
    id: 'slow_experience',
    defaultMessage: 'When real users have a slow experience on mobile, they\'re much less likely to find what they are looking for or purchase from you in the future. For many sites this equates to a huge missed opportunity, especially when more than half of visits are abandoned if a mobile page takes over 3 seconds to load.'
  },
  improve: {
    id: 'improve',
    defaultMessage: 'Last week, Google Search and Ads teams announced two new speed initiatives to help improve user-experience on the web.'
  }
}